<template>
  <div
    v-if="attributes?.slug"
    :class="$style.root"
  >
    <div :class="$style.dateRange">
      <CoreDateTimeRangeComponent
      :dateStart="attributes?.dateStart"
      :dateEnd="attributes?.dateEnd"
      format="D MMM YYYY"
      />&nbsp;<CoreTimeLabelComponent
        :dateStart="attributes?.dateStart"
        :dateEnd="attributes?.dateEnd"
      />
    </div>
    <div :class="$style.title">
      {{ attributes?.title }}
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  data: Object
})

const localizedData = baseStrapiGetLocalizedData(props.data)

const attributes = baseStrapiGetAttributes(localizedData)
const i18nCode = baseI18nGetCodeForIso(attributes?.locale)
</script>

<style module>
.root {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  flex-direction: column;
}

.link {
  composes: reset-link from global;
}

.dateRange {
  composes: font-helvetica font-size-small from global;
}

.title {
  composes: font-size-default from global;
}
</style>
